// What the browser needs before it can do anything, and where it comes from.
//
// Four values, served by this application's own web app from its own app
// settings -- see `server.js`. They are not baked into the bundle: that would
// put a tenant id and a client id in a CI variable and make a configuration
// change a rebuild.
//
// There is deliberately no fallback. A client that guessed an API base URL when
// the document failed to load would send tokens somewhere nobody configured, so
// a failure here stops the application with a message naming the document.

export interface AppConfig {
  readonly tenantId: string;
  readonly apiClientId: string;
  readonly apiScope: string;
  readonly apiBaseUrl: string;
}

let loaded: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (loaded) return loaded;
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(
      `/config.json answered ${response.status}. The client's web app serves it from its app ` +
        'settings; if this is a laptop, put a copy in `public/config.json`.'
    );
  }
  const body = (await response.json()) as Partial<AppConfig>;
  for (const key of ['tenantId', 'apiClientId', 'apiScope', 'apiBaseUrl'] as const) {
    if (!body[key]) throw new Error(`/config.json is missing ${key}.`);
  }
  loaded = body as AppConfig;
  return loaded;
}

export function config(): AppConfig {
  if (!loaded) throw new Error('loadConfig() has not resolved yet.');
  return loaded;
}
